import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _values from "lodash/values";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shouldDisableSubmitButton } from '../components/finalForm/finalFormUtils';
import formSubmissionExceptionHandler from './formSubmissionExceptionHandler';
import useGetSocialOauthError from './hooks/useGetSocialOauthError';
import { sendRegisterFormStartEvent, sendRegisterSubmitEvent } from '../../../../../client/analytics/dataLayerService';
import { REGISTRATION_SOURCES } from '../../../../../client/analytics/dataLayerConstants';
import { fetchInvitationEmail, submitForm } from './registerFormUtils';
import FinalForm from '../components/finalForm/FinalForm';
import FinalField from '../components/finalForm/FinalField';
import PasswordField from '../components/PasswordField';
import CheckboxField from '../components/CheckboxField';
import TextField from '../components/TextField';
import SocialSignInButton from './socialSignIn/SocialSignInButton';
import Button from '../../button/Button';
import FormRow from '../components/FormRow';
import FieldValidationMessages from '../validation/FieldValidationMessages';
import FormError from '../components/FormError';
import GoogleLogo from './socialSignIn/GoogleLogo';
import AppleLogo from './socialSignIn/AppleLogo';
import { getInitialValuesFromQueryString, getSocialSignInUrl } from './registrationUtils';
import { FakePasswordField } from '../components/FakePasswordField';
import { REGISTER_FIELDS } from '../validation/validationConstants';
import './RegisterForm.scss';
var FORM_FIELDS = _values(REGISTER_FIELDS);
var RegisterForm = function RegisterForm() {
  var oauthError = useGetSocialOauthError();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPasswordField = _useState2[0],
    setShowPasswordField = _useState2[1];
  var _useState3 = useState(function () {
      return getInitialValuesFromQueryString();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    initialValues = _useState4[0],
    setInitialValues = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasUpdatedGivenName = _useState6[0],
    setHasUpdatedGivenName = _useState6[1];
  var toggleShowPassword = useCallback(function (event) {
    event.preventDefault();
    setShowPasswordField(function (prevShowPasswordField) {
      return !prevShowPasswordField;
    });
  }, [showPasswordField]);
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var invitationEmail;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!initialValues.inviteCode) {
              _context.next = 5;
              break;
            }
            _context.next = 3;
            return fetchInvitationEmail(initialValues.inviteCode);
          case 3:
            invitationEmail = _context.sent;
            setInitialValues(function (prevInitialValues) {
              return _objectSpread(_objectSpread({}, prevInitialValues), {}, {
                email: invitationEmail
              });
            });
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [initialValues.inviteCode]);

  // Track `Register Form Start` event when given name field is updated
  var onGivenNameUpdated = function onGivenNameUpdated() {
    if (hasUpdatedGivenName) return;
    setHasUpdatedGivenName(true);
    sendRegisterFormStartEvent();
  };
  var onSubmit = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(formValues) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return submitForm(formValues);
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", formSubmissionExceptionHandler(_context2.t0));
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 5]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement(FinalForm, {
    className: "RegisterForm",
    initialValues: initialValues,
    onSubmit: onSubmit,
    fields: FORM_FIELDS
  }, function (formState) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FakePasswordField, null), /*#__PURE__*/React.createElement(FormRow, {
      label: "Your name",
      name: REGISTER_FIELDS.givenName.name,
      errors: [formState.display.errors.givenName, formState.errors.familyName]
    }, /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.givenName
    }, function (_ref3) {
      var input = _ref3.input,
        display = _ref3.display;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        placeholder: "First name",
        error: display.error,
        onInput: onGivenNameUpdated
      }));
    }), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.familyName
    }, function (_ref4) {
      var input = _ref4.input,
        display = _ref4.display;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        placeholder: "Last name",
        error: display.error
      }));
    })), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.email
    }, function (_ref5) {
      var input = _ref5.input,
        display = _ref5.display;
      return /*#__PURE__*/React.createElement(FormRow, {
        label: "Email address",
        name: input.name,
        error: display.error
      }, /*#__PURE__*/React.createElement(TextField, _extends({}, input, {
        error: display.error
      })));
    }), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.password
    }, function (_ref6) {
      var input = _ref6.input,
        display = _ref6.display;
      return /*#__PURE__*/React.createElement(FormRow, {
        label: "Choose a password",
        name: input.name,
        error: display.error
      }, /*#__PURE__*/React.createElement(PasswordField, _extends({}, input, {
        error: display.error,
        showPassword: showPasswordField,
        toggleShowPassword: toggleShowPassword
      })));
    }), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.agreeToTerms
    }, function (_ref7) {
      var input = _ref7.input,
        display = _ref7.display;
      return /*#__PURE__*/React.createElement(CheckboxField, _extends({}, input, {
        error: display.error,
        label: /*#__PURE__*/React.createElement("label", {
          htmlFor: input.name
        }, "I agree to the Milanote", ' ', /*#__PURE__*/React.createElement("a", {
          href: "https://milanote.com/legal/terms-of-service",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "terms"), ' ', "and", ' ', /*#__PURE__*/React.createElement("a", {
          href: "https://milanote.com/legal/privacy-policy",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "privacy policy"))
      }));
    }), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.subscribeToProductUpdates
    }, function (_ref8) {
      var input = _ref8.input,
        display = _ref8.display;
      return /*#__PURE__*/React.createElement(CheckboxField, _extends({}, input, {
        error: display.error,
        label: /*#__PURE__*/React.createElement("label", {
          htmlFor: input.name
        }, "Send me occasional news & updates ", /*#__PURE__*/React.createElement("span", {
          className: "secondary"
        }, "(optional)"))
      }));
    }), /*#__PURE__*/React.createElement(FinalField, {
      field: REGISTER_FIELDS.inviteCode
    }, function (_ref9) {
      var display = _ref9.display;
      return /*#__PURE__*/React.createElement(FieldValidationMessages, {
        sanitisedError: display.error
      });
    }), /*#__PURE__*/React.createElement(Button, {
      className: "submit",
      type: "submit",
      disabled: shouldDisableSubmitButton(formState)
    }, "Submit"), /*#__PURE__*/React.createElement(FormError, {
      className: "primary-error",
      error: formState.submitError || oauthError,
      hide: formState.modifiedSinceLastSubmit || formState.submitting
    }), /*#__PURE__*/React.createElement(SocialSignInButton, {
      className: "MilanoteGoogleSignIn",
      onClick: function onClick() {
        return sendRegisterSubmitEvent(REGISTRATION_SOURCES.OAUTH_GOOGLE);
      },
      href: getSocialSignInUrl('google'),
      logo: /*#__PURE__*/React.createElement(GoogleLogo, null)
    }, "Sign up with Google"), /*#__PURE__*/React.createElement(SocialSignInButton, {
      className: "MilanoteAppleSignIn",
      onClick: function onClick() {
        return sendRegisterSubmitEvent(REGISTRATION_SOURCES.OAUTH_APPLE);
      },
      href: getSocialSignInUrl('apple'),
      logo: /*#__PURE__*/React.createElement(AppleLogo, null)
    }, "Sign up with Apple"), /*#__PURE__*/React.createElement("div", {
      className: "disclaimer"
    }, "This site is protected by reCAPTCHA and the Google", ' ', /*#__PURE__*/React.createElement("a", {
      href: "https://policies.google.com/terms"
    }, "terms of service"), " and", ' ', /*#__PURE__*/React.createElement("a", {
      href: "https://policies.google.com/privacy"
    }, "privacy policy"), " apply"));
  });
};
RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  showPasswordField: PropTypes.bool,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  error: PropTypes.string,
  oauthError: PropTypes.string,
  initialValues: PropTypes.object,
  toggleShowPassword: PropTypes.func,
  fetchInviteInformation: PropTypes.func
};
export default RegisterForm;